import { CheckCircle2 } from "lucide-react";

export default function InterviewComplete() {
  return (
    <main
      data-testid="interview-complete-page"
      className="grain-overlay flex min-h-screen flex-col items-center justify-center bg-slate-900 px-6 text-center text-white"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/10">
        <CheckCircle2 className="h-8 w-8 text-emerald-400" />
      </div>
      <h1 className="mt-8 font-heading text-4xl font-semibold tracking-tight sm:text-5xl">
        Thanks, you're all set.
      </h1>
      <p className="mt-4 max-w-md text-base text-slate-400">
        Your answers have been submitted, transcribed, and scored. The hiring
        team will be in touch soon.
      </p>
      <div className="mt-10 text-xs font-bold uppercase tracking-[0.2em] text-blue-300">
        You can safely close this tab.
      </div>
    </main>
  );
}
